import { Subject } from 'rxjs';
import { authService } from './service';
import { apiState } from '../../api/instance';

export class AuthStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.subject = new Subject();
    this.mobileToken = {};
    // UI-стейт диалога логина
    this.loginDialogOpen = false;
    // UI-стейт диалога выбора города (открывается из шапки)
    this.cityBranchDialogOpen = false;
    // polling-таймер для типа `client_call`
    this._callPollTimer = null;
  }

  // ---------- mutations
  _emit() { this.subject.next(this); }

  setLoginDialogOpen(v) {
    this.loginDialogOpen = !!v;
    this._emit();
  }
  toggleLoginDialog() { this.setLoginDialogOpen(!this.loginDialogOpen); }

  setCityBranchDialogOpen(v) {
    this.cityBranchDialogOpen = !!v;
    this._emit();
  }

  // ---------- polling для логина по звонку
  startCallStatusPolling(onAuthed) {
    this.stopCallStatusPolling();
    const tick = async () => {
      try { await this.bootstrap(); } catch (e) { /* ignore */ }
      if (this.isAuthenticated) {
        this.stopCallStatusPolling();
        if (onAuthed) onAuthed();
        return;
      }
      this._callPollTimer = setTimeout(tick, 2500);
    };
    this._callPollTimer = setTimeout(tick, 2500);
  }
  stopCallStatusPolling() {
    if (this._callPollTimer) { clearTimeout(this._callPollTimer); this._callPollTimer = null; }
  }

  setMobileToken(token) {
    this.mobileToken = token || {};
    apiState.setMobileToken(this.mobileToken.token || null);
    if (this.rootStore.cartStore && this.mobileToken.cart) {
      this.rootStore.cartStore.setCart(this.mobileToken.cart);
    }
    this._emit();
  }

  // ---------- selectors
  get isAuthenticated() {
    const ci = this.mobileToken && this.mobileToken.client_info;
    return ci && Object.keys(ci).length > 0;
  }

  get companyInfo() { return this.mobileToken.company_info || {}; }

  get authType() {
    return (this.companyInfo.auth_type && this.companyInfo.auth_type.login_type) || 'sms';
  }

  get phoneMaskInfo() {
    return (this.companyInfo.auth_type && this.companyInfo.auth_type.phones_login_info) || {};
  }

  get cityBranches() { return this.companyInfo.city_branches || []; }
  get cityBranch() { return this.mobileToken.city_branch || null; }
  get clientInfo() { return this.mobileToken.client_info || null; }
  get coupledTokens() { return this.mobileToken.coupled_mobile_tokens || []; }
  // Зоны доставки текущего филиала: [{coords: [[lat,lng], ...]}, ...].
  get deliveryZones() {
    const districts = this.mobileToken.districts || [];
    const out = [];
    districts.forEach((d) => {
      (d.zones || []).forEach((z) => {
        if (z && z.coords && z.coords.length) out.push(z);
      });
    });
    return out;
  }

  // ---------- actions
  async bootstrap() {
    const token = apiState.getMobileToken();
    const res = await authService.getOrUpdateToken(token);
    this.setMobileToken(res.mobile_token);
    return this.mobileToken;
  }

  async setCity(cityBranchId) {
    const res = await authService.setCity(cityBranchId);
    this.setMobileToken(res.mobile_token);
  }

  async setLang(lang) {
    const res = await authService.setLang(lang);
    this.setMobileToken(res.mobile_token);
  }

  async sendSmsCode(phone) {
    return authService.sendSmsCode(phone);
  }

  async submitSmsCode(code) {
    const res = await authService.submitSmsCode(code);
    this.setMobileToken(res.mobile_token);
    return res;
  }

  async submitPhoneForCall(phone) {
    return authService.submitPhoneForCall(phone);
  }

  async loginByEmail(email, password) {
    const res = await authService.loginByEmail(email, password);
    this.setMobileToken(res.mobile_token);
    return res;
  }

  async logout() {
    const res = await authService.logout();
    this.setMobileToken(res.mobile_token);
  }

  async createCoupled() {
    const res = await authService.createCoupledToken();
    this.setMobileToken(res.mobile_token);
  }

  async updateClientInfo(patch) {
    const res = await authService.updateClientInfo(patch);
    this.setMobileToken(res.mobile_token);
  }

  async updateAvatar(file) {
    const res = await authService.updateAvatar(file);
    this.setMobileToken(res.mobile_token);
  }

  async removeAvatar() {
    const res = await authService.removeAvatar();
    this.setMobileToken(res.mobile_token);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/authStore/index.js